export default "data:application/octet-stream;base64,PHRlbXBsYXRlPgogIDxkaXY+PC9kaXY+CjwvdGVtcGxhdGU+Cg=="